import { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { filter, isEmpty, isNil } from 'ramda';
import ProgressBar from '@components/@core/ProgressBar';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import * as Instances from '@components/CareerRequiredInstances';
import TrainingCourses from '~/views/Manage/Reports/TrainingCourses';
import { length } from '~/services/util';

const QuotaHeader = () => (
    <div className="career-required-instances">
        <div className="quotas pt-4">
            <p className="dsl-b18 text-500 mb-3">Goals</p>
            <div className="list py-2 px-1 desktop-screen border-bottom">
                <div className="d-flex-6">
                    <div className="dsl-m12">Goal</div>
                </div>
                <div className="d-flex-3">
                    <div className="dsl-m12">Calculation</div>
                </div>
                <div className="d-flex-3">
                    <div className="dsl-m12">Greater/Less Than</div>
                </div>
                <div className="d-flex-1">
                    <div className="dsl-m12">Target</div>
                </div>
                <div className="d-flex-1">
                    <div className="dsl-m12">Actual</div>
                </div>
                <div className="d-flex-2">
                    <div className="dsl-m12">Status</div>
                </div>
            </div>
        </div>
    </div>
);

const Detail = ({ levels = [], current = 1}) => {
    const [active, setActive] = useState(!isEmpty(levels) ? 0 : '');

    const currentLevel = levels?.[active] || {};
    const completedQuotas = filter((e) => !isNil(e.completed_at), currentLevel.quotas ?? []);
    const progress = length(currentLevel.quotas) > 0 ? ((completedQuotas.length / length(currentLevel.quotas)) * 100).toFixed(2) : 100;
    const trainings = currentLevel?.trainings?.items || [];
    const courses = filter((e) => e.card_type_id === 1, trainings);
    
    useEffect(() => {
        setActive(current - 1);
    }, [current]);

    if (isNil(levels[current - 1])) {
        return (
            <div className="lib-programs-career">
                <div className="career-content">
                    <p className="dsl-m14 mb-0">No plan contents.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="lib-programs-career">
            <div className="career-content card-header mb-0">
                <p className="dsl-b22 bold mb-3">Requirements</p>
                <p className="dsl-b16 mb-8 word-break">
                    The following Goals and Learning must be completed in order to advance to the next level in your Health Plan.
                </p>
                <ResponsiveTabs
                    className="mb-3"
                    active={`${active}`}
                    data={levels?.map((level, index) => ({
                        id: `${index}`,
                        name: level?.title?.length > 15 ? `${level.title?.substring(0, 15)}...` : level?.title || 'NA',
                    }))}
                    onTab={(e) => setActive(e.id)}
                />
                <QuotaHeader />
                {length(currentLevel.quotas) > 0 ? <Instances.QuotasDetail data={currentLevel.quotas} stat type="instance" programType="certificate" /> : <p className="dsl-b16 py-4 mb-0 border-bottom">No Quotas Assigned</p>}
                <div className="d-flex ai-center jc-end mt-4">
                    <span className="dsl-b16 bold">Goals completed</span>
                    <span className="dsl-b16 mx-3">{length(completedQuotas)}/{length(currentLevel.quotas)}</span>
                    <ProgressBar value={progress} />
                </div>
                <TrainingCourses data={courses} />
            </div>
        </div>
    );
};

Detail.propTypes = {
    levels: PropTypes.array,
    current: PropTypes.number,
};

export default memo(Detail);
